import { render } from "./MatchScore.vue?vue&type=template&id=6abe6c8d&scoped=true"
import script from "./MatchScore.vue?vue&type=script&lang=js"
export * from "./MatchScore.vue?vue&type=script&lang=js"

import "./MatchScore.vue?vue&type=style&index=0&id=6abe6c8d&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6abe6c8d"]])

export default __exports__